import { memo } from "react";

import MaterialInputBase from "@mui/material/InputBase";
import { styled, Theme } from "@mui/material/styles";

import {
  getBaseInputContainerStyles,
  getBaseInputErrorStyles,
  getBaseInputFocusedStyles,
  getSizeStyles,
  getRightLeftPadding,
  getBaseInputInputStyles,
} from "./styleHelpers";
import { zeffyInputClasses } from "./types";

export const StyledInputBase = memo(
  styled(MaterialInputBase)(({ theme }: { theme: Theme }) => ({
    [`&.${zeffyInputClasses.root}`]: {},
    [`&.${zeffyInputClasses.neutral}`]: getBaseInputContainerStyles("neutral", theme),
    [`&.${zeffyInputClasses.form}`]: getBaseInputContainerStyles("form", theme),
    [`& .${zeffyInputClasses.input}`]: getBaseInputInputStyles(theme),

    [`&.${zeffyInputClasses.multiline}`]: {
      [`& .${zeffyInputClasses.input}`]: {
        height: "100%",
      },
    },

    [`&.${zeffyInputClasses.error}`]: getBaseInputErrorStyles(theme),
    [`&.${zeffyInputClasses.focused}`]: getBaseInputFocusedStyles(theme),
    [`& .${zeffyInputClasses.medium}`]: getSizeStyles("medium", theme),
    [`& .${zeffyInputClasses.small}`]: getSizeStyles("small", theme),
    [`&.${zeffyInputClasses.disabled}`]: {},

    [`&.${zeffyInputClasses.adornedStart}`]: {
      paddingLeft: getRightLeftPadding(theme),
      backgroundColor: theme.palette.surface.neutral.white,
    },

    [`&.${zeffyInputClasses.adornedEnd}`]: {
      paddingRight: getRightLeftPadding(theme),
      backgroundColor: theme.palette.surface.neutral.white,
      [`&.${zeffyInputClasses.disabled}`]: {
        backgroundColor: theme.palette.surface.neutral.moderate,
      },
    },

    [`& .${zeffyInputClasses.inputAdornedStart}`]: {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
      marginLeft: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5),
      backgroundColor: theme.palette.surface.neutral.white,
    },

    [`& .${zeffyInputClasses.inputAdornedEnd}`]: {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      marginRight: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      backgroundColor: theme.palette.surface.neutral.white,
      "&:disabled": {
        backgroundColor: theme.palette.surface.neutral.moderate,
      },
    },

    [`&.${zeffyInputClasses.noPadding}, & .${zeffyInputClasses.noPadding}`]: {
      padding: 0,
    },
  }))
);
